import { render, staticRenderFns } from "./ShowClientApprovalRequest.vue?vue&type=template&id=c1ab9bd6"
import script from "./ShowClientApprovalRequest.vue?vue&type=script&lang=js"
export * from "./ShowClientApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports